$(function(){

    $('#address-book').addressBook();

    $('.update-states').getCountryStates();

    $('#service_login').preventDoubleSubmission({
        showLoading: true,
        targetSelector: '.button-loader:first'
    });

});